import Image_ISEC from "./ISEC2024.jpg";
import Image_coverJAB from "./coverJAB_small.jpg";
import Image_ASAB from "./asab2022_small.jpg";
import Image_PhD from "./PhD_defense.jpg";
import Image_EAAFSSM from "./best-student-paper_EAAFSSM_small.png";
import Image_water from "./Editor_choice_MDPI_Water.jpg";
const NEWS = [
   {
    title:
      "Presentation on little owl dispersal movements at the International Statistical Ecology Conference",
    text:
      "Postdoc project on little owl natal dispersal movements was presented at the International Statistical Ecology Conference 2024, held in Swansea, UK. Learnt a lot from all the talks, posters, and workshops!",
       image: Image_ISEC,
    url: "https://chrissuthy.quarto.pub/international-statistical-ecology-conference/",
  },

    {
    title:
      "Article featured on the cover of Journal of Avian Biology",
    text:
      "Our article about how our satellite tracking work revealed the migration of the Anadyr bar-tailed godwit was featured on the cover of the August issue of the Journal of Avian Biology.",
       image: Image_coverJAB,
    url: "https://www.avianbiology.org/content/august-2022",
  },
   {
    title:
      "Proud to organise ASAB Winter Meeting with the theme 'Animal Movement'",
    text:
      "After months of hard work as part of the scientific organising committee, I am very proud that the conference on Animal Movement of the Association Association for the Study of Animal Behaviour has been successfully held in Edingburgh. We brought together 300 researchers from around the globe for a frutiful 2-day of scientific exchange. I can feel the enthusiasm expressed by many of finally meeting each other face-to-face after almost 3 years since the first COVID lockdown and travel bans. Still there are people who could not be here and we have organised hublets around the globe to follow the conference remotely.",
    image: Image_ASAB,
    url: "https://openpub.fmach.it/retrieve/7c5b2be1-67a4-41f4-bed0-b43748e45307/2022_ASABWinter%2036.pdf",
  },
   {
    title:
      "PhD awarded!",
    text:
      "The PhD thesis: Struggles Ashore - Migration Ecology of Threatened Shorebirds in the East Asian-Australasian Flyway was successfully defended on 28 May 2021.",
    image: Image_PhD,
    url: "https://chanyingchi.github.io/phdthesis",
  },
  {
    title:
      "Best Student Paper award at the 1st East Asian-Australasian Shorebird Science meeting!",
    text:
      "Ginny Chan, a PhD student at the University of Groningen and the Royal Netherlands Insitute for Sea Research, has been awarded the Best Student Paper award in the EAA Shorebird Science meeting held on 3-5 November 2020. The title of her talk is 'Applications of satellite tracking of shorebirds in coastal conservation'. Congratulations!",
    image: Image_EAAFSSM,
    url: "https://www.eaaflyway.net/1st-eaafssm-report/",
  },
  {
    title: "Our MDPI Water Paper has been chosen as 'Editor‘s Choice Article'",
    text: (
      <span>
        We are delighted to hear that our recent open-access publication
        entitled 'Building for Nature: Preserving Threatened Bird Habitat in
        Port Design' has been selected as <i>Editor's Choice Article</i> of
        Water journal.
      </span>
    ),
    image: Image_water,
    url: "https://www.mdpi.com/2073-4441/12/8/2134",
  },
];

export default NEWS;
